Monitoring.Views ||= {}

class AccountSettings.TaxonomiesEditorView extends Backbone.View
  template: JST["backbone/templates/account_settings/taxonomies/editor"]

  events:
    'change #taxonomy-name': 'onChangeName'
    'change #taxonomy-code': 'onChangeCode'
    'change #taxonomy-active': 'onChangeActivation'
    'change #taxonomy-hierarchy': 'onChangeHierarchy'
    'focusout #taxonomy-name': 'onFocusOutName'
    'click #cancel': 'onClickCancel'
    'click #save': 'onClickSave'

  initialize: (@options = {}) ->
    @taxonomy           = @options.taxonomy
    @originalName       = @taxonomy.get('name')
    @originalCode       = @taxonomy.get('code')
    @originalActivation = @taxonomy.get('active')
    @originalHierarchy  = @taxonomy.get('hierarchy')

  render: =>
    @$el.html(@template(@))
    @initializeModal()
    @initializeToggle()
    @updateSaveButtonStatus()
    @

  initializeModal: ->
    @$el.find('#taxonomy-edit').modal()

  initializeToggle: ->
    @$el.find('#taxonomy-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
      height: '20px'
    })

  updateSaveButtonStatus: =>
    if @allMandatoryFieldsAreFilled() and @atLeastOneFieldChanged()
      @$el.find('#save').prop('disabled', false)
    else
      @$el.find('#save').prop('disabled', true)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled() and @hierarchyIsFilled() and @codeIsFilled()

  atLeastOneFieldChanged: =>
    @nameChanged() or @codeChanged() or @hierarchyChanged() or @activationChanged()

  nameIsFilled: ->
    @$el.find('#taxonomy-name').val().trim().length > 0

  hierarchyIsFilled: ->
    @$el.find('#taxonomy-hierarchy').val().trim().length > 0

  codeIsFilled: ->
    @$el.find('#taxonomy-code').val().trim().length > 0

  nameChanged: =>
    @originalName != @$el.find('#taxonomy-name').val().trim()

  codeChanged: =>
    @originalCode != @$el.find('#taxonomy-code').val().trim()

  activationChanged: =>
    @originalActivation != @$el.find('#taxonomy-active').prop('checked')

  hierarchyChanged: =>
    @originalHierarchy != @$el.find('#taxonomy-hierarchy').val().trim()

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @updateSaveButtonStatus()

  onChangeHierarchy: (evt) ->
    @onChangeTextProperty('hierarchy')
    @updateSaveButtonStatus()

  onChangeCode: (evt) ->
    @onChangeTextProperty('code')
    @updateSaveButtonStatus()

  onChangeActivation: (evt) ->
    @onChangeCheckboxProperty('active')
    @updateSaveButtonStatus()

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#taxonomy-#{propertyName}").val().trim()
    @taxonomy.set(propertyName, enteredProperty)

  onChangeCheckboxProperty: (propertyName) ->
    enteredProperty = @$el.find("#taxonomy-#{propertyName}").prop('checked')
    @taxonomy.set(propertyName, enteredProperty)

  onFocusOutName: (evt) ->
    if @$el.find('#taxonomy-code').val() == ''
      @$el.find('#taxonomy-code').val(@taxonomy.get('name').replace(/ /g, ''))
      @onChangeTextProperty('code')

  onClickCancel: ->
    @trigger('cancel')

  onClickSave: ->
    valid = @taxonomy.validateFields()
    if valid
      @$el.find('.saving').html(I18n.t('monitoring.taxonomy.saving'))
      @taxonomy.save({}, {
        success: (response) =>
          @$el.find('#taxonomy-edit').modal('hide')
          @trigger('afterSave', @taxonomy)
        error: (response) =>
          @$el.find('.saving').html('Error')
          console.log("Error saving alert: #{response}")
      })
    @$el.find('.saving').html(I18n.t('monitoring.taxonomy.save'))
    false
